"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    SignInMarkerComponent: ()=>SignInMarkerComponent
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
require("react");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_TravelBotLogoImage_js_namespaceObject = require("./TravelBotLogoImage.js");
const MessageFooter_js_namespaceObject = require("./components/MessageFooter/MessageFooter.js");
var MessageFooter_js_default = /*#__PURE__*/ __webpack_require__.n(MessageFooter_js_namespaceObject);
function SignInMarkerComponent(props) {
    const { signedIn, onSigninClick } = props;
    const onClickHandler = ()=>{
        window.PCLN?.pclnEventDispatcher?.dispatch('GLOBAL_PCLN_LAUNCH_SIGNIN_MODAL');
    };
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
        mb: 3,
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.ChatMessage, {
                variation: "initial",
                Icon: external_TravelBotLogoImage_js_namespaceObject.TravelBotLogoImage,
                footer: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(MessageFooter_js_default(), {}),
                message: signedIn ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                    mb: 3,
                    fontSize: 2,
                    children: "Looks like you're already signed in! You're welcome to ask additional questions if you have any!"
                }) : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
                    flexDirection: "column",
                    children: [
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                            mb: 3,
                            fontSize: 2,
                            children: "Click the button below to Sign In."
                        }),
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                            fontSize: 2,
                            children: "To safeguard your privacy, this chat will be cleared upon signing in."
                        })
                    ]
                })
            }),
            !signedIn && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Flex, {
                ml: 3,
                mt: 3,
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Button, {
                    variation: "subtle",
                    onClick: onSigninClick || onClickHandler,
                    children: "Sign In"
                })
            })
        ]
    });
}
exports.SignInMarkerComponent = __webpack_exports__.SignInMarkerComponent;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "SignInMarkerComponent"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
